import React, { useContext, useState, useEffect } from 'react'
import { Form, Button, Row, Col, Card, Container, Input} from 'react-bootstrap';
import { useNavigate } from 'react-router'
import { updatePass } from "./apiCalls";
import Sidebar from './Sidebar';
import ToastConfirmation from './ToastConfirmation';

import { store, StateProvider } from '../../Store';

export default function ChangePassword() {

  const navigate = useNavigate();
  const {state, dispatch} = useContext(store);
  const [validated, setValidated] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [response, setResponse] = useState({});

  const [formData, setFormData] = useState({
    user: 'admin',
    password: '',
    newPassword1: '',
    newPassword2: ''
  });

  useEffect (() => {
    if (response?.msg && response.msg === 'Wrong password.') {
      alert('Contraseña incorrecta, intente nuevamente');
    } else if (response?.msg && response.msg === 'ok') {
      setShowToaster(true);
    }
  }, [response]);

  const submitNewPassword = () => {
    if (formData.newPassword1 !== formData.newPassword1) {
      alert("Passwords don't match");
    } else {
      updatePass(formData.password, formData.newPassword1, async (r) => {return await setResponse(r)})
    }
  };

  // validate submit form  
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      // event.preventDefault();
      event.stopPropagation();
    } else if (formData.newPassword1 !== formData.newPassword2) {
      alert('Las contraseña ingresada no es la misma 2 veces');
      // event.preventDefault();
      event.stopPropagation();
    } else if (formData.password === formData.newPassword1) {
      alert('Las contraseña no puede ser la misma que la original');
      // event.preventDefault();
      event.stopPropagation();
    }
    
    setValidated(true);
  };    

  const loginForm = (
    <>
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Form.Group className="admin-content-group">
      <div className="login-text-box">
      <Form.Control
        type="password"
        id="inputPassword"
        className="form-control"
        placeholder="Contraseña actual"
        required
        onChange={(e) => {
          setFormData({
            ...formData,
            'password': e.target.value
          });
        }}
      />
      </div>
      <div className="login-text-box">
      <Form.Control
        type="password"
        id="inputPassword"
        className="form-control"
        placeholder="Nueva contraseña"
        required
        onChange={(e) => {
          setFormData({
            ...formData,
            'newPassword1': e.target.value
          });
        }}
      />
      </div>
      <div className="login-text-box">
      <Form.Control
        type="password"
        id="inputPassword"
        className="form-control"
        placeholder="Ingrese nueva contraseña de nuevo"
        required
        onChange={(e) => {
          setFormData({
            ...formData,
            'newPassword2': e.target.value
          });
        }}
      />
      </div>
      <div className="login-text-box">
        <Button className="odisea-form-button-submit" type="submit" onClick={submitNewPassword}>Cambiar contraseña</Button>
      </div>
      </Form.Group>
    </Form>
    </>
  )
  return (
    <>
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs = {3} />
          <Col xs={4} className="admin-content">
            <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contraseña actualizada con éxito!' }/>
            <Card>
              <Card.Header> Cambio de contraseña </Card.Header>
              <Card.Body>{ loginForm }</Card.Body>
            </Card>
          </Col> 
          <Col xs = {3} />
      </Row>
    </Container>
   </>
  )
}
